import type { WarrantyStatus } from "@shared/modules/x-garanties";

/** Variantes de `Badge` du noyau (le type n'y est pas exporté). */
export type BadgeVariant = "neutral" | "primary" | "success" | "warning" | "danger";

/** Couleurs de statut : tokens seulement, via les variantes de pastille du noyau. */
export const STATUS_VARIANT: Record<WarrantyStatus, BadgeVariant> = {
  brouillon: "neutral",
  envoyee: "primary",
  signee: "success",
  expiree: "warning",
  annulee: "danger",
};
